import { useCallback, useMemo } from 'react'
import { ScrollText } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchSecurityPolicies, SEC_STR as S, type PolicyRow } from './securityMoreApi'

/**
 * A18.24 — Политики безопасности. Password/session/2FA/IP policy registry.
 * Fail-soft empty until the `/admin/security/policies` settings surface ships.
 */
export function SecurityPoliciesScreen() {
  const columns = useMemo<AdminColumn<PolicyRow>[]>(
    () => [
      { key: 'name', header: S.policyName, type: 'text' },
      { key: 'category', header: S.category, type: 'text', width: 160 },
      { key: 'scope', header: S.scope, type: 'text', width: 150 },
      { key: 'enforced', header: S.enforced, type: 'bool', width: 120, align: 'center' },
      { key: 'updated_at', header: S.updated, type: 'date', width: 150 },
    ],
    [],
  )
  const fetcher = useCallback(fetchSecurityPolicies, [])
  return (
    <>
      <PageHeader title={S.policies} screenId="A18.24" />
      <DataTable<PolicyRow>
        screenId="A18.24"
        permission={PERMISSIONS.AUDIT_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => r.id}
        exportable
        emptyState={{ icon: <ScrollText size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
